<svg:svg [attr.width]="168"
         [attr.height]="24"
         x="0"
         y="0">
    <!-- <svg:rect x="0"
              y="0"
              [attr.width]="cfg.navigationSize.width"
              [attr.height]="cfg.navigationSize.height"
              [attr.rx]="7">
    </svg:rect> -->
    <svg:svg x="0"
             y="0"
             [attr.width]="cfg.cellWidth"
             [attr.height]="cfg.cellHeight"
             (click)="onPrevYear()"
             [ngClass]="{ inactive: isPrevYearDisabled }">
        <svg:path d="M18,6 V18 L6,12 Z"
                  transform="translate(-3)" />
        <svg:path d="M18,6 V18 L6,12 Z"
                  transform="translate(3)" />
    </svg:svg>
    <svg:svg x="24"
             y="0"
             [attr.width]="cfg.cellWidth"
             [attr.height]="cfg.cellHeight"
             (click)="onPrevMonth()"
             [ngClass]="{ inactive: isPrevMonthDisabled }">
        <svg:path d="M18,6 V18 L6,12 Z" />
    </svg:svg>
    <svg:svg [attr.x]="cfg.navigationSize.width - (2 * cfg.cellWidth)"
             y="0"
             [attr.width]="cfg.cellWidth"
             [attr.height]="cfg.cellHeight"
             (click)="onNextMonth()"
             [ngClass]="{ inactive: isNextMonthDisabled }">
        <svg:path d="M6,6 V18 L18,12 Z" />
    </svg:svg>
    <svg:svg [attr.x]="cfg.navigationSize.width - cfg.cellWidth"
             y="0"
             [attr.width]="cfg.cellWidth"
             [attr.height]="cfg.cellHeight"
             (click)="onNextYear()"
             [ngClass]="{ inactive: isNextYearDisabled }">
        <svg:path d="M6,6 V18 L18,12 Z"
                  transform="translate(-3)" />
        <svg:path d="M6,6 V18 L18,12 Z"
                  transform="translate(3)" />
    </svg:svg>
    <svg:text class="temporal"
              x="50%"
              y="50%"
              dy="4"
              dominant-baseline="auto"
              text-anchor="middle">
        {{ displayRange }}
    </svg:text>
</svg:svg>
